import { render, staticRenderFns } from "./shortkeys.vue?vue&type=template&id=4519f066"
import script from "./shortkeys.vue?vue&type=script&lang=ts"
export * from "./shortkeys.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports